import { useState, useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { getAcceptObject } from "../FileUpload.utils";

const useDropzoneUpload = ({
  acceptedFileTypes,
  multiple = true,
  onDrop,
  onDropRejected
}) => {
  const [hover, setHover] = useState(false);

  const handleDrop = useCallback((acceptedFiles) => {
    if (onDrop) onDrop(acceptedFiles);
  }, [onDrop]);

  const handleDropRejected = useCallback((rejectedFiles) => {
    if (onDropRejected) onDropRejected(rejectedFiles);
  }, [onDropRejected]);

  const {
    getRootProps,
    getInputProps,
    open: openFileDialog
  } = useDropzone({
    accept: getAcceptObject(acceptedFileTypes),
    noClick: true,
    onDrop: handleDrop,
    onDropRejected: handleDropRejected,
    multiple
  });

  // Wrap open to allow for future extension
  const open = () => {
    openFileDialog();
  };

  return {
    hover,
    setHover,
    getRootProps,
    getInputProps,
    open
  };
};

export default useDropzoneUpload;
